<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('kotBotPrinter.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('kotBotPrinter.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('kotBotPrinter.branchName') }}</label>
                  <ts-branch-filter
                    @filter="branchFilter"
                    class="ts-w-full"
                  ></ts-branch-filter>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'printer_name'
        }"
      >
        <template v-slot="{ record }">
          <td>{{ record.branch ? record.branch.branch_name_en : '' }}</td>
          <td>
            {{
              record.pro_group
                ? record.pro_group.pro_group_name_en
                : ''
            }}
          </td>
          <td>
            <span
              v-if="
                record.branch_id != model.branch_id ||
                  record.pro_group_id != model.pro_group_id
              "
              >{{ record.printer_name }}</span
            >
            <input
              v-model="model.printer_name"
              type="text"
              class="form-control"
              v-if="
                record.branch_id == model.branch_id &&
                  record.pro_group_id == model.pro_group_id
              "
            />
          </td>
          <td class="text-center">
            <span
              v-if="
                record.branch_id != model.branch_id ||
                  record.pro_group_id != model.pro_group_id
              "
              >{{ record.receipt_type }}</span
            >
            <select
              v-model="model.receipt_type"
              v-if="
                record.branch_id == model.branch_id &&
                  record.pro_group_id == model.pro_group_id
              "
              class="form-control"
            >
              <option
                v-for="(type, i) in types"
                :value="type"
                :key="i"
                :label="type"
              >
                {{ type }}
              </option>
            </select>
          </td>
          <td>
            {{
              record.created_by
                ? record.created_by.employee.employee_name_en
                : ''
            }}
          </td>
          <td>{{ record.created_date }}</td>
          <td class="text-center ts-space-x-3 ts-whitespace-no-wrap">
            <ts-button
              v-if="
                record.branch_id == model.branch_id &&
                  record.pro_group_id == model.pro_group_id
              "
              class="btn-xs btn-primary"
              @click="update(record)"
            >
              <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
              <i class="fa fa-save" v-else></i>
            </ts-button>
            <ts-button
              @click="cancel"
              v-if="
                record.branch_id == model.branch_id &&
                  record.pro_group_id == model.pro_group_id
              "
              class="btn-xs btn-default"
            >
              <i class="fa fa-times"></i>
            </ts-button>
            <a
              v-if="
                record.branch_id != model.branch_id ||
                  record.pro_group_id != model.pro_group_id
              "
              href="#"
              v-tooltip="$t('edit')"
              class="text-primary"
              @click.prevent="edit(record)"
            >
              <i class="fas fa-edit"></i>
            </a>
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('kotBotPrinter.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="400px"
      >
        <from-action @cancel="clearEdit" @fetchData="fetchData" />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'kotBotPrinterIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false,
      model: {
        branch_id: null,
        pro_group_id: null,
        printer_name: null,
        receipt_type: null
      },
      types: ['KOT', 'BOT']
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('restaurantSale/kotBotPrinter', [
      'resources',
      'pagination',
      'edit_data'
    ]),
    search: {
      get() {
        return this.$store.state.restaurantSale.kotBotPrinter.search
      },
      set(newValue) {
        this.$store.commit('restaurantSale/kotBotPrinter/SET_SEARCH', newValue)
        this.$store.commit('restaurantSale/kotBotPrinter/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('kotBotPrinter.branchName') },
        { name: this.$t('kotBotPrinter.productGroup') },
        { name: this.$t('kotBotPrinter.printerName') },
        {
          name: this.$t('kotBotPrinter.receiptType'),
          style: 'text-align:center;'
        },
        { name: this.$t('kotBotPrinter.createdBy') },
        { name: this.$t('kotBotPrinter.createdDate') },
        { name: this.$t('actions'), style: 'text-align:center; width: 10px;' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('restaurantSale/kotBotPrinter/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    edit(record) {
      this.model.branch_id = record.branch_id
      this.model.pro_group_id = record.pro_group_id
      this.model.printer_name = record.printer_name
      this.model.receipt_type = record.receipt_type
    },
    clearEdit(){
      this.showForm = false
		},
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('restaurantSale/kotBotPrinter/destroy', {
          branch_id: record.branch_id,
          pro_group_id: record.pro_group_id
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    branchFilter(value) {
      this.$store.commit('restaurantSale/kotBotPrinter/SET_BRANCH_ID', value)
      this.fetchData()
    },
    update(record) {
      record._deleting = true
      this.$store
        .dispatch('restaurantSale/kotBotPrinter/update', {
          id: this.model.pro_group_id,
          data: this.model
        })
        .then(response => {
          record._deleting = false
          this.$toasted.success(response.message)
          this.fetchData()
          this.cancel()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          record._deleting = false
        })
    },
    cancel() {
      this.model = {
        branch_id: null,
        pro_group_id: null,
        printer_name: null,
        receipt_type: null
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('restaurantSale/kotBotPrinter/RESET_STATE')
    next()
  }
}
</script>
